import { apiClient } from '~services/api'
import {
  OfferDetailsInput,
  OfferDetailsResponse,
  OffersListInput,
  OffersListResponse,
  RedeemOfferInput,
  RedeemOfferResponse,
} from '~types/offer'

export const getOffersRequest = (params: OffersListInput) => {
  const paramsObject = {
    ...params,
    categoryId: JSON.stringify(params.categoryId),
    locations: JSON.stringify(params.locations),
  }
  return apiClient.get<OffersListResponse, OffersListResponse, OffersListInput>('/offers', {
    params: paramsObject,
  })
}

export const getOfferDetailsRequest = ({
  offerId,
}: OfferDetailsInput): Promise<OfferDetailsResponse> => {
  return apiClient.get<OfferDetailsResponse, OfferDetailsResponse>(`/offers/${offerId}`)
}

export const redeemOfferRequest = (data: RedeemOfferInput): Promise<RedeemOfferResponse> => {
  return apiClient.post<RedeemOfferResponse, RedeemOfferResponse>('/buy-offer', data)
}
